import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export let SendMailModelActionService = /*#__PURE__*/(() => {
  class SendMailModelActionService {
    constructor(router) {
      this.router = router;
    }
    openMailerForCustomRecipient(email, name) {
      const state = {
        recipients: [
        // TODO: should user id be included if available?
        {
          type: 'custom',
          name: name,
          email: email,
          data: {
            recipient: {
              email: email,
              name: name
            }
          }
        }]
      };
      this.router.navigate(['/mailer'], {
        state
      });
    }
    openMailerForUser(id, name) {
      if (typeof id === 'string') id = parseInt(id, 10);
      const state = {
        recipients: [{
          type: 'user',
          id: id,
          name: name
          // email:item.email,
        }]
      };
      this.router.navigate(['/mailer'], {
        state
      });
    }
    static {
      this.ɵfac = function SendMailModelActionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SendMailModelActionService)(i0.ɵɵinject(i1.Router));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: SendMailModelActionService,
        factory: SendMailModelActionService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SendMailModelActionService;
})();